import { Component, OnInit } from "@angular/core";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import { UtilsService } from "app/auth/service/utils.service";
import { AuthenticationService } from "app/auth/service";
import { Router } from "@angular/router";
import { ProductsService } from "app/modules/products/products.service";
import { IProductList } from "app/modules/products/models/products";

@Component({
  selector: "app-products-list",
  templateUrl: "./products-list.component.html",
  styleUrls: ["./products-list.component.scss"],
})
export class ProductsListComponent implements OnInit {
  public contentHeader: IContentHeader = null;
  public searchKey: string = "";
  public tableLimit: number = 10;
  public productsList: IProductList[] = [];
  public filterProductsList: IProductList[] = [];
  public selectedProduct: IProductList = null;

  constructor(
    public _utilService: UtilsService,
    public _authenticationService: AuthenticationService,
    private router: Router,
    private _productsService: ProductsService,
  ) {
    this.contentHeader = {
      headerTitle: "PRODUCTS",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: "PRODUCTS",
            isLink: false,
          },
          {
            name: "LIST",
            isLink: false,
          },
        ],
      },
    };
  }

  async ngOnInit() {
    if (!this._authenticationService.hasCapability("show_menu_products")) {
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    await this.loadProducts();
  }
  async loadProducts() {
    this.productsList = await this._productsService.getProductsList();
    this.search();
  }

  updateTableLimit(event: { target: { value: string } }): void {
    this.tableLimit = Number(event.target.value);
  }

  search() {
    let filteredArray: IProductList[] = this.productsList;

    if (this.searchKey && this.searchKey.length > 0) {
      const key: string = this.searchKey.toLowerCase();
      filteredArray = filteredArray.filter((product: IProductList) => product.name.toLowerCase().includes(key));
    }
    this.filterProductsList = filteredArray;
  }

  goEdit(product: IProductList) {
    this.selectedProduct = null;
    this.selectedProduct = product;
    this._utilService.popupOpenProductForm = true;
  }

  async delete(product: IProductList) {
    if (!this._authenticationService.hasCapability("delete_product")) {
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }

    let deleteText: string = await this._utilService.translate("ALERT.CONFIRM_DELETE_TEXT");
    deleteText += await this._utilService.translate("ALERT.CONFIRM_DELETE_THIS_OBJECT");
    deleteText += ` ${product?.name}`;

    await this._utilService
      .showSWALDeleteConfirmation({ text: deleteText })
      .then(async (result) => {
        if (result.value) {
          this._utilService.showLoading();
          await this._productsService
            .deleteProduct(product.id)
            .then(async () => {
              await this.loadProducts();
              this._utilService.hideLoading();
              await this._utilService.showSWALSuccess({ text: "SUCCESS_DELETE_PRODUCT" });
            })
            .catch(async () => {
              this._utilService.hideLoading();
              await this._utilService.showSWALError({ text: "ERROR_DELETE_PRODUCT" });
            });
        } else if (result.isDismissed) {
          this._utilService.hideLoading();
          await this._utilService.showSWALError({
            title: "ABORTED_TITLE",
            text: "ABORTED_TEXT",
          });
        }
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_DELETE_PRODUCT" });
      });
  }
}
